import * as Sentry from '@sentry/react';
import { makeFetchTransport, makeMultiplexedTransport } from '@sentry/browser';
import { config } from 'config';

const enabled =
  !!config.sentryDsn &&
  ![config.env, config.robinEnv].some(
    (env) => env === 'development' || env === 'test'
  );

// Configure multiplexed transport to route errors to different Sentry projects
// based on the 'dsn' tag. Events without a tag go to the default DSN.
const transport = makeMultiplexedTransport(
  makeFetchTransport,
  ({ getEvent }) => {
    const event = getEvent(['event', 'transaction', 'replay_event']);

    if (!event) {
      return [];
    }

    // Route to relevant DSN based on the tag
    if (event.tags?.dsn) {
      return [event.tags.dsn as string];
    }

    // Default: route to shell project (empty array means use default DSN)
    return [];
  }
);

Sentry.init({
  enabled: enabled,
  environment: config.robinEnv,
  dsn: config.sentryDsn,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  normalizeDepth: 10,
  transport: transport,
});

export { Sentry };
